import { useToast } from 'primevue/usetoast';

export function useNotifications() {
  const toast = useToast();

  const showError = (message) => {
    toast.add({
      severity: 'error',
      summary: 'Error',
      detail: message,
      life: 5000, // 5 seconds
    });
  };

  const showSuccess = (message) => {
    toast.add({
      severity: 'success',
      summary: 'Success',
      detail: message,
      life: 3000, // 3 seconds
    });
  };

  return { showError, showSuccess };
}
